import { MINT_APP_CDN_URL } from "../../../config";

export const ThreeDModelViewer = ({
  modelUrl,
  onLoad,
}: {
  modelUrl: string;
  onLoad?: () => void;
}) => {
  const viewerUrl = `${MINT_APP_CDN_URL}/3d-viewer.html`;
  return (
    <iframe
      sandbox={`allow-scripts`}
      allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
      src={`${viewerUrl}?modelUrl=${encodeURIComponent(modelUrl)}`}
      style={{ width: "100%", height: "100%", border: "none" }}
      onLoad={onLoad}
    ></iframe>
  );
};
